import { BaseIcon } from 'chemistry'
import React from 'react'

const FilterIcon = props => {
  return (
    <BaseIcon width='24px' height='24px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <g stroke='#413F33' strokeLinecap='round' strokeLinejoin='round'>
          <path d='M3 4h7M14 4h7M3 12h9M16 12h5M3 20h5M12 20h9M10 1v6M16 9v6M8 17v6' />
        </g>
      </g>
    </BaseIcon>
  )
}

export default FilterIcon
